module.exports = __webpack_public_path__ + "img/item8.01ada121.png";